import React from 'react';

const FieldHintAndError = ({ field, hint }) => {
  try {
    const hasError = field.state.meta.isTouched && field.state.meta.errors.length > 0;
    //console.log('FieldHintAndError', { field, hint, hasError });
    
    // Extract and deduplicate error messages
    const uniqueErrorMessages = hasError ? Array.from(new Set(
      field.state.meta.errors.map(err => {
        if (typeof err === 'string') {
          return err;
        } else if (err && typeof err === 'object' && 'message' in err) {
          return err.message;
        } else {
          console.error(err);
          return 'Unknown error';
        }
      })
    )) : [];
    
    return (
      <div className="space-y-1">
        {hasError && (
          <ul className="text-sm text-destructive space-y-1">
            {uniqueErrorMessages.map((message, i) => (
              <li key={i}>{message}</li>
            ))}
          </ul>
        )}
        
        {hint && (
          <p className="text-sm text-muted-foreground">
            {hint}
          </p>
        )}
      </div>
    );
  } catch (error) {
    return (
      <p className="text-sm text-destructive">Error: {error.message}</p>
    );
  }
};

export { FieldHintAndError };
